var map = {
	"./calculator/bg.png": "LB3p",
	"./favicon.png": "Yhqy",
	"./luidy.jpg": "YYis",
	"./my-lista/my-lista.png": "O0l0",
	"./natours/nat-1.jpg": "O1w9",
	"./natours/nat-2.jpg": "XbAh",
	"./natours/nat-3.jpg": "SOyn",
	"./natours/nat-4.jpg": "cl3d",
	"./natours/nat-5.jpg": "YVCA",
	"./natours/nat-6.jpg": "18Dx",
	"./natours/nat-gif.gif": "imbZ",
	"./trillo/tri-1.jpg": "xkMw",
	"./trillo/tri-2.jpg": "I8T1",
	"./trillo/tri.gif": "VSaX"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2qD";